// 是否是安卓
export function isAndroid() {
  return /Android/.test(navigator.userAgent);
}

// 是否是IOS
export function isIOS() {
  return /iPhone|iPad|iPod|Apple/.test(navigator.userAgent) && !window.MSStream;
}

// 查看作业详情调用APP方法
export function callAppMethod(methodName: string, params: Record<string, any> | string = {}) {
  try {
    let newParams: any = params;
    if (typeof params === "object") {
      newParams = JSON.stringify(params);
    }
    if (isAndroid()) {
      return window.Android[methodName](newParams);
    } else if (isIOS()) {
      window.webkit.messageHandlers[methodName].postMessage(newParams);
    }
  } catch (error) {
    console.log("当前环境无法和原生端通信", error);
  }
}
